import { useState, useEffect } from "react";
import { AnimatePresence } from "motion/react";
import { Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import "@/index.css";
import { Navbar } from "@/components/ui/mini-navbar";

import LoadingScreen from "./components/LoadingScreen";

// Pages
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Services from "./pages/Services";
import Blogs from "./pages/Blogs";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";

// Blog Posts
import WhyWebsite from "./pages/blog/WhyWebsite";
import WhyAutomation from "./pages/blog/WhyAutomation";
import CustomApps from "./pages/blog/CustomApps";
import AIMarketing from "./pages/blog/AIMarketing";
import AIAgents from "./pages/blog/AIAgents";
import AIChatbots from "./pages/blog/AIChatbots";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  const triggerLoading = () => {
    setIsLoading(true);
    window.scrollTo({ top: 0, behavior: "instant" });
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  useEffect(() => {
    // Reduced artificial delay to 2 seconds for a snappier experience
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  // When route changes, reset scroll to top
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="bg-black min-h-screen position-relative">

      <AnimatePresence>
        {isLoading && <LoadingScreen key="loading" />}
      </AnimatePresence>

      <div className={`relative z-10 transition-opacity duration-1000 ${isLoading ? "opacity-0" : "opacity-100"}`}>
        <Navbar onLogoClick={triggerLoading} />
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/why-your-business-needs-a-website" element={<WhyWebsite />} />
          <Route path="/blog/why-automation-is-better-for-business" element={<WhyAutomation />} />
          <Route path="/blog/custom-apps-that-help-your-business-grow" element={<CustomApps />} />
          <Route path="/blog/ai-powered-marketing-strategies-for-business" element={<AIMarketing />} />
          <Route path="/blog/what-are-ai-agents-and-how-they-help-your-business" element={<AIAgents />} />
          <Route path="/blog/how-ai-chatbots-transform-customer-service" element={<AIChatbots />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
        
        <Footer />
        <Chatbot />
      </div>
    </div>
  );
}

export default App;
